import styled from '@emotion/styled';

import IconCheckCircle from 'components/icons/checkCircle';

export const Icon = styled(IconCheckCircle)((props) => ({
  overflow: 'visible',
  color: props.theme.colors.text.accent,
}));
